import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { getNameInitials } from "../../utils";
var UserIcon = function UserIcon(props) {
  var name = props.name,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("rounded-full bg-gray-300 dark:bg-gray-800 flex items-center justify-center font-[14px] text-gray-800 dark:text-white", _defineProperty({}, className, !!className))
  }, getNameInitials(name));
};
export default UserIcon;